import { Button, useToken } from '@chakra-ui/react';

import { hexToRGBA } from '@/client/utils/hexToRGBA';
import { useTranslation } from 'react-i18next';

interface IntegrationButtonProps {
  isEnabled: boolean | undefined;
  onClick: () => void;
}

export default function IntegrationButton({ isEnabled, onClick }: IntegrationButtonProps) {
  const { t } = useTranslation();
  const [brandButton] = useToken('colors', ['brand.button']);

  return (
    <Button
      variant="outline"
      border="2px solid"
      borderRadius="8px"
      paddingX={8}
      paddingY={3}
      fontSize="16px"
      fontWeight={600}
      width={28}
      color={isEnabled ? 'neutral.800' : 'brand.button'}
      borderColor={isEnabled ? 'neutral.800' : 'brand.button'}
      _hover={{
        backgroundColor: isEnabled ? 'neutral.100' : hexToRGBA(brandButton, 0.1),
      }}
      onClick={onClick}
    >
      {isEnabled
        ? t('learners.profile.settings.integrations.remove')
        : t('learners.profile.settings.integrations.enable')}
    </Button>
  );
}
